import styled from 'styled-components';
import {COLORS, FONTS, SIZES} from '@fupa/fupa-uikit';

const ActivityList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: ${SIZES['16']};

  list-style-type: none;
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 0;

  ${props => props.theme.streamLayoutOneColBig`
    max-width: ${props.theme.mobileContentWidth}px;
  `}

  ${props => props.theme.desktopLayout`
    max-width: ${props.theme.desktopContentWidth}px;
  `}
`;

const Wrapper = styled.li`
  background-color: ${COLORS.white};
  display: block;
  width: 100%;
  max-width: ${props => props.theme.mobileContentWidth}px;

  ${props => props.theme.streamLayoutOneColBig`
      border-radius: ${SIZES['4']};
      border: 1px solid ${COLORS.lightGrey};
  `}

  ${props =>
    props.theme.desktopLayout`
      height: fit-content;
      border-radius: ${SIZES['4']};
      border: 1px solid ${COLORS.lightGrey};
      max-width: ${props.theme.elementsWidth2Columns}px;
    `}
`;

const IconContainer = styled.div<{color: string}>`
  width: ${SIZES['36']};
  height: ${SIZES['36']};
  background-color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${SIZES['8']};
  border-radius: 50%;
  font-size: ${FONTS['20']};
`;

export {ActivityList, Wrapper, IconContainer};
